export default __webpack_public_path__ + "static/media/47.2b0ed177.jpeg";